import { render, staticRenderFns } from "./SupplierGroupList.vue?vue&type=template&id=033af268"
import script from "./SupplierGroupList.vue?vue&type=script&lang=js"
export * from "./SupplierGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports